// extracted by mini-css-extract-plugin
export var header_scrolled = "header-module--header_scrolled--RUB0T";
export var header_scrolled_sp = "header-module--header_scrolled_sp--+2rSM";
export var container = "header-module--container--i1m8L";
export var symbols = "header-module--symbols--NWeVp";
export var img_park_direct = "header-module--img_park_direct--49SAW";
export var menus = "header-module--menus---Mjgn";